@if (currentTask && currentTask.columns?.length > 0) {
    <p-overlayPanel #op styleClass="shadow-md" (onHide)="clearInput()">
        <ng-template pTemplate="content">
            <div class="w-22rem border-round-lg">
                <div class="p-3 border-bottom-1 surface-border border-round-top-lg">
                    <div class="mb-2 flex align-items-center justify-content-between">
                        <p class="text-semibold m-0 text-lg">
                            {{ 'default-cm-columns' | translate: 'Columns' }} ({{ columnArray.length }})
                        </p>
                        <p-button
                            styleClass="shadow-none"
                            [disabled]="selectedCount === 0"
                            [text]="true"
                            (click)="ClearAll()"
                            >{{ 'default-cm-clearAll' | translate: 'Clear All' }}</p-button
                        >
                    </div>
                    <div>
                        <span class="p-input-icon-left w-full h-full flex justify-content-end">
                            <input
                                #searchInput
                                [ngModel]="searchValue"
                                type="text"
                                pInputText
                                class="p-inputtext-sm w-full"
                                placeholder="{{ 'default-cm-searchColumns' | translate: 'Search for columns' }}"
                                (input)="getColumns(searchInput.value)"
                            />
                            <i class="pi pi-search"></i>
                            @if (searchInput.value) {
                                <i class="pi pi-times mx-2 cursor-pointer" (click)="clearInput(searchInput)"></i>
                            }
                        </span>
                    </div>
                </div>
                <div
                    class="overflow-auto h-22rem"
                    (dndDrop)="onDrop($event, columnArray)"
                    dndDropzone
                    dndEffectAllowed="copyMove"
                >
                    <div dndPlaceholderRef class="h-3rem border-round-md h-3rem m-2 border-1 surface-border"></div>
                    @if (columns.length == 0) {
                        <div class="flex flex-column align-items-center justify-content-center h-full">
                            <img class="w-7 h-7" src="assets/icons/no-result-found.svg" alt="" />
                        </div>
                    } @else {
                        @for (column of columns; track column.label; let index = $index) {
                            <div
                                class="single-column cursor-grab border-bottom-1 surface-border flex justify-content-between align-items-center p-3 line-height-3 hover:surface-hover"
                                [dndDraggable]="column"
                                dndEffectAllowed="move"
                                (dndMoved)="onDragged(column, columnArray)"
                            >
                                <div class="text-normal flex align-items-center gap-12 text-color">
                                    <img src="assets/icons/drag-icon.svg" alt="" srcset="" />
                                    {{ column['translatedLabel'] }}
                                </div>
                                <p-checkbox
                                    type="checkbox"
                                    [ngModel]="!column.hideable"
                                    [binary]="true"
                                    (onChange)="selectCheckboxes(column)"
                                ></p-checkbox>
                            </div>
                        }
                    }
                </div>
                <div class="border-top-1 surface-border flex justify-content-between align-items-center p-3 gap-20">
                    <div class="text-semibold">
                        {{ selectedCount }} {{ 'default-cm-selected' | translate: 'Selected' }}
                    </div>
                    <div class="buttons">
                        <p-button
                            styleClass="shadow-none"
                            label="{{ 'default-cm-applyColumn' | translate: 'Apply column' }}"
                            [disabled]="selectedCount === 0"
                            (click)="applyColumn($event, op)"
                        ></p-button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-overlayPanel>
    <p-button
        (click)="op.toggle($event)"
        [outlined]="true"
        styleClass="min-w-min"
        [pTooltip]="'default-cm-columns' | translate: 'Columns'"
        tooltipPosition="bottom"
    >
        <span class="flex align-items-center">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <g id="Group">
                    <path
                        id="Vector"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M2 4.33333C2 3.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333ZM9.33333 3.33333H6.66667V12.6667H9.33333V3.33333ZM10.6667 3.33333H12.6667V12.6667H10.6667V3.33333ZM5.33333 12.6667V3.33333H3.33333V12.6667H5.33333Z"
                        fill="#265EBE"
                    />
                </g>
            </svg>
        </span>
    </p-button>
}
